// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"912":"e87781aa","1953":"770af07e","4580":"ffd8d7b8","5496":"ffd8d7b8","6586":"8328febd","7951":"ffd8d7b8","9592":"3c7a390f"}[chunkId] + ".chunk.css";
};